export const CHECKLIST_GROUPS = [
  {
    title: "Kitchen",
    items: [
      "Oven interior, racks, trays and door glass degreased",
      "Hob, extractor filters and splashbacks descaled",
      "Fridge and freezer defrosted, washed inside and out",
      "Microwave, kettle and toaster cleaned",
      "Inside and outside of all cupboards & drawers",
      "Worktops, sink and taps polished, limescale removed",
      "Floors washed and skirting boards wiped",
    ],
  },
  {
    title: "Bathroom",
    items: [
      "Bath, shower screen and tiles descaled and polished",
      "Toilet sanitised inside, outside and behind",
      "Sink, taps and mirror polished streak-free",
      "Grout and silicone scrubbed where reachable",
      "Extractor fans wiped and dust removed",
      "Cabinets emptied and wiped inside and out",
      "Floors washed and corners detailed",
    ],
  },
  {
    title: "Bedrooms & Living Areas",
    items: [
      "All surfaces dusted including tops of wardrobes & doors",
      "Inside of wardrobes, drawers and shelving wiped",
      "Skirting boards, picture rails and trim hand-cleaned",
      "Light switches, sockets and door handles sanitised",
      "Mirrors and internal glass polished",
      "Carpets vacuumed thoroughly (steam clean as an add-on)",
      "Hard floors washed and edge-detailed",
    ],
  },
  {
    title: "Hallways, Stairs & Extras",
    items: [
      "Stair carpets and treads vacuumed and edged",
      "Banisters and balustrades hand-wiped",
      "Internal doors, frames and tops cleaned",
      "Light fittings and ceiling vents dusted",
      "Inside windows, frames and sills cleaned",
      "Radiators wiped front, top and behind where accessible",
      "Communal entry items (intercom, mat) tidied",
    ],
  },
];

export const PROCESS = [
  {
    title: "Free online quote",
    description:
      "Send us the property size, postcode and your move-out date. You receive a fixed, all-in quote with no hidden add-ons within a few working hours.",
  },
  {
    title: "We schedule your slot",
    description:
      "Choose a date that aligns with your checkout. We coordinate with your letting agent or inventory clerk so the timing works for everyone.",
  },
  {
    title: "Inventory-grade clean",
    description:
      "A trained team of two to four cleaners arrives with all equipment, dip-tanks for the oven and carpet extractors if booked.",
  },
  {
    title: "Walkthrough & guarantee",
    description:
      "We walk through the property with you (or send photos if you have already left) and back the work with a 7-day re-clean guarantee.",
  },
];

export const boroughs = [
  {
    name: "Hackney",
    slug: "hackney",
    postcodes: ["E2", "E5", "E8", "E9", "N1", "N16"],
    areas: "Dalston, Shoreditch, Stoke Newington, London Fields, Clapton and Homerton",
    intro:
      "Hackney has one of London's highest tenant turnovers, with a large private rental sector across Dalston, Shoreditch and Stoke Newington. Our end of tenancy cleaning teams serve every Hackney postcode — E2, E5, E8, E9, N1 and N16 — with same-day availability at month-end when the majority of ASTs expire.",
    nearby: ["islington", "tower-hamlets", "camden"],
  },
  {
    name: "Islington",
    slug: "islington",
    postcodes: ["N1", "N4", "N5", "N7", "EC1"],
    areas: "Angel, Highbury, Holloway, Finsbury Park, Barnsbury and Canonbury",
    intro:
      "Islington's private rental market spans everything from period conversions in Barnsbury to modern builds near Angel and King's Cross. We clean across all Islington postcodes — N1, N4, N5, N7 and EC1 — and regularly work with letting agents on the Upper Street and Essex Road corridors.",
    nearby: ["hackney", "camden", "westminster"],
  },
  {
    name: "Camden",
    slug: "camden",
    postcodes: ["NW1", "NW3", "NW5", "NW6"],
    areas: "Camden Town, Primrose Hill, Kentish Town, Hampstead, Belsize Park and Kilburn",
    intro:
      "Camden's rental market covers a wide range — from studios in Camden Town to large family homes in Hampstead. Our teams cover NW1, NW3, NW5 and NW6 with the full inventory-grade specification letting agents expect across this sought-after north London borough.",
    nearby: ["islington", "westminster", "barnet"],
  },
  {
    name: "Lambeth",
    slug: "lambeth",
    postcodes: ["SW2", "SW4", "SW9", "SE11", "SE24", "SE27"],
    areas: "Brixton, Clapham, Stockwell, Streatham, Tulse Hill and West Norwood",
    intro:
      "Lambeth stretches from the South Bank to Streatham, covering Brixton, Clapham and Stockwell — some of south London's busiest rental areas. We serve SW2, SW4, SW9, SE11, SE24 and SE27 with same-day and weekend availability throughout the borough.",
    nearby: ["wandsworth", "southwark", "lewisham", "croydon"],
  },
  {
    name: "Wandsworth",
    slug: "wandsworth",
    postcodes: ["SW11", "SW12", "SW15", "SW17", "SW18"],
    areas: "Battersea, Balham, Tooting, Putney, Earlsfield and Clapham South",
    intro:
      "Wandsworth is one of London's most active rental boroughs, with strong demand across Battersea, Balham and Tooting. We cover SW11, SW12, SW15, SW17 and SW18, and regularly work alongside Wandsworth's major letting agents on inventory-grade end of tenancy cleans.",
    nearby: ["lambeth", "southwark", "hammersmith"],
  },
  {
    name: "Southwark",
    slug: "southwark",
    postcodes: ["SE1", "SE5", "SE15", "SE16", "SE17"],
    areas: "London Bridge, Bermondsey, Peckham, Elephant & Castle, Camberwell and Canada Water",
    intro:
      "Southwark covers a dense rental market from London Bridge and Bermondsey through to Peckham and Nunhead. We serve SE1, SE5, SE15, SE16 and SE17, with teams that know the inventory standards used by the borough's estate agents and housing associations.",
    nearby: ["lambeth", "lewisham", "tower-hamlets", "greenwich"],
  },
  {
    name: "Tower Hamlets",
    slug: "tower-hamlets",
    postcodes: ["E1", "E2", "E3", "E14"],
    areas: "Canary Wharf, Bethnal Green, Stepney, Bow, Whitechapel and Poplar",
    intro:
      "Tower Hamlets has a concentrated rental market across Canary Wharf, Bethnal Green and Whitechapel. We cover E1, E2, E3 and E14, and regularly clean new-build apartments in Canary Wharf and Isle of Dogs to the exact standard required by managing agents on those developments.",
    nearby: ["hackney", "southwark", "greenwich"],
  },
  {
    name: "Greenwich",
    slug: "greenwich",
    postcodes: ["SE3", "SE7", "SE9", "SE10"],
    areas: "Greenwich, Blackheath, Eltham, Charlton and Woolwich",
    intro:
      "Greenwich combines period properties in Blackheath and Greenwich Village with newer developments along the river and near Woolwich. Our teams cover SE3, SE7, SE9 and SE10, and are familiar with the checkout standards required by Greenwich and Blackheath's established letting agents.",
    nearby: ["lewisham", "southwark", "tower-hamlets"],
  },
  {
    name: "Lewisham",
    slug: "lewisham",
    postcodes: ["SE4", "SE6", "SE8", "SE12", "SE13", "SE14", "SE23"],
    areas: "Lewisham, Catford, Brockley, Deptford, Forest Hill, Hither Green and Ladywell",
    intro:
      "Lewisham's growing rental market spans Brockley, Deptford and Forest Hill — areas popular with first-time renters and young professionals. We cover SE4, SE6, SE8, SE12, SE13, SE14 and SE23, with competitive pricing and a full 7-day re-clean guarantee on every job.",
    nearby: ["southwark", "greenwich", "bromley", "lambeth"],
  },
  {
    name: "Hammersmith",
    slug: "hammersmith",
    postcodes: ["W6", "W12", "W14", "SW6"],
    areas: "Hammersmith, Fulham, Shepherd's Bush, Brook Green and Barons Court",
    intro:
      "Hammersmith and Fulham is home to one of west London's most active rental markets, from riverside apartments in Fulham to conversions in Shepherd's Bush. Our teams cover W6, W12, W14 and SW6 with the inventory-grade cleaning standard that local agencies require at checkout.",
    nearby: ["chelsea", "wandsworth", "camden"],
  },
  {
    name: "Chelsea",
    slug: "chelsea",
    postcodes: ["SW3", "SW5", "SW10", "W8"],
    areas: "Chelsea, Earl's Court, West Brompton, Kensington and Notting Hill Gate",
    intro:
      "Chelsea and Kensington properties demand an exceptional cleaning standard — inventory clerks working for premium London agencies apply strict checkout criteria to high-value apartments. Our teams cover SW3, SW5, SW10 and W8, trained to the same specification used by Knight Frank, Savills and Foxtons on these properties.",
    nearby: ["hammersmith", "westminster", "wandsworth"],
  },
  {
    name: "Westminster",
    slug: "westminster",
    postcodes: ["SW1", "W1", "W2", "WC1", "WC2"],
    areas: "Pimlico, Victoria, Mayfair, Marylebone, Paddington, Bayswater and Covent Garden",
    intro:
      "Westminster covers central London's most high-value rental postcodes — Mayfair, Marylebone, Pimlico and Bayswater. Our teams serve SW1, W1, W2, WC1 and WC2, and regularly complete checkout cleans in luxury serviced apartments and period properties managed by premium central London agencies.",
    nearby: ["chelsea", "camden", "islington"],
  },
  {
    name: "Barnet",
    slug: "barnet",
    postcodes: ["N2", "N3", "N12", "N20", "NW4", "NW7", "NW11"],
    areas: "Finchley, Barnet, Golders Green, Mill Hill, Edgware and Hendon",
    intro:
      "Barnet is one of north London's largest rental boroughs, with strong demand across Finchley, Golders Green and Hendon. We cover N2, N3, N12, N20, NW4, NW7 and NW11, with teams experienced in the family homes and purpose-built flats typical of this area.",
    nearby: ["camden", "islington"],
  },
  {
    name: "Bromley",
    slug: "bromley",
    postcodes: ["BR1", "BR2", "BR3", "BR6"],
    areas: "Bromley, Beckenham, Penge, Orpington, Chislehurst and West Wickham",
    intro:
      "Bromley has a steady rental market across its suburban town centres — Beckenham, Bromley town and Orpington see consistent tenant turnover. We cover BR1, BR2, BR3 and BR6, providing the same inventory-grade end of tenancy cleaning standard applied across all 32 London boroughs.",
    nearby: ["lewisham", "greenwich", "croydon"],
  },
  {
    name: "Croydon",
    slug: "croydon",
    postcodes: ["CR0", "CR2", "CR3", "CR4", "CR7"],
    areas: "Croydon, Thornton Heath, South Croydon, Purley, Norbury and Mitcham",
    intro:
      "Croydon has grown significantly as a rental market, with a mix of apartments near East Croydon station and family homes across Thornton Heath and South Croydon. We cover CR0, CR2, CR3, CR4 and CR7, with same-day and weekend availability to fit around the borough's high volume of month-end checkouts.",
    nearby: ["bromley", "lambeth", "wandsworth"],
  },
  {
    name: "Brent",
    slug: "brent",
    postcodes: ["NW2", "NW6", "NW9", "NW10", "HA0", "HA9"],
    areas: "Wembley, Kilburn, Cricklewood, Willesden, Harlesden and Neasden",
    intro:
      "Brent has one of north-west London's most diverse and active rental markets, with strong demand across Wembley, Kilburn and Willesden. We cover NW2, NW6, NW9, NW10, HA0 and HA9, providing inventory-grade end of tenancy cleaning with same-day and weekend availability throughout the borough.",
    nearby: ["camden", "barnet", "harrow", "ealing"],
  },
  {
    name: "Ealing",
    slug: "ealing",
    postcodes: ["W5", "W7", "W13", "UB1", "UB2", "UB6"],
    areas: "Ealing, Acton, Hanwell, Southall, Greenford and Perivale",
    intro:
      "Ealing covers a wide range of rental properties from period conversions in Acton to modern builds near Ealing Broadway. We serve W5, W7, W13, UB1, UB2 and UB6, with teams experienced in the checkout standards expected by Ealing's letting agents across this busy west London borough.",
    nearby: ["hammersmith", "hounslow", "hillingdon", "brent"],
  },
  {
    name: "Enfield",
    slug: "enfield",
    postcodes: ["EN1", "EN2", "EN3", "N9", "N13", "N14", "N18", "N21"],
    areas: "Enfield Town, Southgate, Edmonton, Palmers Green, Winchmore Hill and Bowes Park",
    intro:
      "Enfield is one of north London's largest boroughs, with a steady rental market across Enfield Town, Southgate and Edmonton. We cover EN1, EN2, EN3, N9, N13, N14, N18 and N21, delivering the same inventory-grade cleaning standard that letting agents across the borough require at checkout.",
    nearby: ["barnet", "haringey"],
  },
  {
    name: "Haringey",
    slug: "haringey",
    postcodes: ["N4", "N8", "N10", "N11", "N15", "N17", "N22"],
    areas: "Wood Green, Tottenham, Hornsey, Crouch End, Muswell Hill and Seven Sisters",
    intro:
      "Haringey's rental market spans everything from Victorian terraces in Crouch End to purpose-built flats near Tottenham Hale. We cover N4, N8, N10, N11, N15, N17 and N22, and regularly work alongside letting agents on the Wood Green and Green Lanes corridors.",
    nearby: ["islington", "hackney", "barnet", "enfield"],
  },
  {
    name: "Harrow",
    slug: "harrow",
    postcodes: ["HA1", "HA2", "HA3", "HA5", "HA7"],
    areas: "Harrow, Harrow on the Hill, Pinner, Stanmore, Wealdstone and Kenton",
    intro:
      "Harrow has a substantial rental market across its suburban town centres, with strong demand in Harrow town centre, Pinner and Stanmore. We cover HA1, HA2, HA3, HA5 and HA7, providing full inventory-grade end of tenancy cleaning for tenants, landlords and letting agents throughout the borough.",
    nearby: ["brent", "barnet", "hillingdon"],
  },
  {
    name: "Havering",
    slug: "havering",
    postcodes: ["RM1", "RM2", "RM3", "RM5", "RM7", "RM11", "RM12", "RM13", "RM14"],
    areas: "Romford, Hornchurch, Upminster, Harold Wood, Gidea Park and Rainham",
    intro:
      "Havering covers a busy outer east London rental market centred on Romford and Hornchurch. We serve RM1, RM2, RM3, RM5, RM7, RM11, RM12, RM13 and RM14, with the same 7-day re-clean guarantee and inventory-grade specification we deliver across all 32 London boroughs.",
    nearby: ["barking-and-dagenham", "redbridge"],
  },
  {
    name: "Hillingdon",
    slug: "hillingdon",
    postcodes: ["UB3", "UB4", "UB5", "UB7", "UB8", "UB10", "HA4", "HA6"],
    areas: "Uxbridge, Hayes, Ruislip, Northolt, Yiewsley and West Drayton",
    intro:
      "Hillingdon is one of west London's largest boroughs, with a strong rental market across Uxbridge, Hayes and Ruislip. We cover UB3, UB4, UB5, UB7, UB8, UB10, HA4 and HA6, and regularly complete end of tenancy cleans for properties near Heathrow and along the Elizabeth line corridor.",
    nearby: ["ealing", "harrow", "hounslow"],
  },
  {
    name: "Hounslow",
    slug: "hounslow",
    postcodes: ["TW3", "TW4", "TW5", "TW7", "TW8", "W4"],
    areas: "Hounslow, Feltham, Brentford, Chiswick, Isleworth and Hanworth",
    intro:
      "Hounslow has a diverse rental market ranging from riverside apartments in Chiswick and Brentford to family homes across Feltham and Hanworth. We cover TW3, TW4, TW5, TW7, TW8 and W4, with teams that understand the checkout standards used by Hounslow's major letting agents.",
    nearby: ["ealing", "richmond", "hillingdon", "hammersmith"],
  },
  {
    name: "Kingston upon Thames",
    slug: "kingston",
    postcodes: ["KT1", "KT2", "KT3", "KT4"],
    areas: "Kingston, New Malden, Surbiton, Tolworth and Chessington",
    intro:
      "Kingston upon Thames combines a busy town-centre rental market with quieter residential streets in Surbiton and New Malden. We cover KT1, KT2, KT3 and KT4, providing inventory-grade end of tenancy cleaning with full weekend availability to fit around Kingston's high volume of month-end checkouts.",
    nearby: ["richmond", "merton", "sutton"],
  },
  {
    name: "Merton",
    slug: "merton",
    postcodes: ["SW19", "SW20", "CR4", "SM4"],
    areas: "Wimbledon, Mitcham, Morden, Raynes Park and Colliers Wood",
    intro:
      "Merton's rental market is anchored by Wimbledon and Raynes Park, with growing demand across Colliers Wood and Morden near the Northern line. We serve SW19, SW20, CR4 and SM4, delivering the same inventory-grade cleaning standard and 7-day re-clean guarantee on every job across the borough.",
    nearby: ["wandsworth", "lambeth", "croydon", "sutton", "kingston"],
  },
  {
    name: "Newham",
    slug: "newham",
    postcodes: ["E6", "E7", "E12", "E13", "E15", "E16"],
    areas: "Stratford, West Ham, East Ham, Forest Gate, Plaistow and Canning Town",
    intro:
      "Newham has one of London's fastest-growing rental markets, driven by regeneration around Stratford and the Olympic Park. We cover E6, E7, E12, E13, E15 and E16, with teams experienced in cleaning the new-build apartments and converted properties that dominate Newham's rental stock.",
    nearby: ["tower-hamlets", "hackney", "barking-and-dagenham", "redbridge", "waltham-forest"],
  },
  {
    name: "Redbridge",
    slug: "redbridge",
    postcodes: ["IG1", "IG2", "IG3", "IG4", "IG5", "IG6", "E11", "E18"],
    areas: "Ilford, Woodford, Wanstead, Barkingside, South Woodford and Gants Hill",
    intro:
      "Redbridge covers a large and active rental market across Ilford, Woodford and Wanstead. We serve IG1, IG2, IG3, IG4, IG5, IG6, E11 and E18, providing full inventory-grade end of tenancy cleaning for tenants and landlords throughout the borough with same-day and weekend availability.",
    nearby: ["newham", "barking-and-dagenham", "waltham-forest", "havering"],
  },
  {
    name: "Richmond upon Thames",
    slug: "richmond",
    postcodes: ["TW9", "TW10", "TW11", "TW12", "TW1", "TW2", "SW14", "SW13"],
    areas: "Richmond, Twickenham, Teddington, Barnes, Kew and Mortlake",
    intro:
      "Richmond upon Thames has some of south-west London's most desirable rental properties, from riverside homes in Barnes and Kew to period conversions in Twickenham. We cover TW9, TW10, TW11, TW12, TW1, TW2, SW14 and SW13, cleaning to the high standard required by Richmond's premium letting agents.",
    nearby: ["hounslow", "kingston", "wandsworth", "hammersmith"],
  },
  {
    name: "Sutton",
    slug: "sutton",
    postcodes: ["SM1", "SM2", "SM3", "SM5", "SM6"],
    areas: "Sutton, Cheam, Carshalton, Wallington and Worcester Park",
    intro:
      "Sutton has a steady south London rental market with strong demand across Sutton town centre, Cheam and Carshalton. We cover SM1, SM2, SM3, SM5 and SM6, delivering full inventory-grade end of tenancy cleaning with the 7-day re-clean guarantee that local letting agents rely on.",
    nearby: ["merton", "croydon", "kingston"],
  },
  {
    name: "Waltham Forest",
    slug: "waltham-forest",
    postcodes: ["E10", "E11", "E17", "E4"],
    areas: "Walthamstow, Leyton, Leytonstone, Chingford and Highams Park",
    intro:
      "Waltham Forest has become one of east London's most active rental boroughs, with surging demand across Walthamstow and Leyton following the area's rapid regeneration. We cover E10, E11, E17 and E4, providing inventory-grade end of tenancy cleaning with same-day availability throughout the borough.",
    nearby: ["hackney", "newham", "redbridge", "haringey"],
  },
  {
    name: "Barking and Dagenham",
    slug: "barking-and-dagenham",
    postcodes: ["RM8", "RM9", "RM10", "IG11"],
    areas: "Barking, Dagenham, Becontree, Chadwell Heath and Rush Green",
    intro:
      "Barking and Dagenham has a large and growing rental market, with strong demand across Barking town centre and the Becontree estate. We cover RM8, RM9, RM10 and IG11, delivering the same inventory-grade end of tenancy cleaning and 7-day re-clean guarantee that we provide across all 32 London boroughs.",
    nearby: ["newham", "havering", "redbridge"],
  },
  {
    name: "Bexley",
    slug: "bexley",
    postcodes: ["DA5", "DA6", "DA7", "DA14", "DA15", "DA16", "SE2"],
    areas: "Bexleyheath, Sidcup, Welling, Erith, Crayford, Belvedere and Abbey Wood",
    intro:
      "Bexley is one of south-east London's quieter but steadily active rental boroughs, with a mix of family homes in Sidcup and Bexleyheath and newer builds near Abbey Wood. We cover DA5, DA6, DA7, DA14, DA15, DA16 and SE2, providing full inventory-grade end of tenancy cleaning throughout the borough.",
    nearby: ["greenwich", "bromley"],
  },
];
